import React, { useMemo, useState, useEffect } from "react";
import './App.css';

/* ------------ DATA (your exact products) ------------ */
const PRODUCTS = [
  {
    id: "feiyue",
    name: "FEIYUE Fe Lo 1920 Low Top Canvas Performance Shoe",
    img: "https://m.media-amazon.com/images/I/51oHCxbr0oL._AC_SL1200_.jpg",
    price: 35.0,
    rating: 4.3,
    link: "https://www.amazon.com/dp/B089QY3FGC?tag=paht4change-20",
    sole: "Rubber (flexible, low profile)",
    upper: "Canvas",
    tags: ["Indoor", "Outdoor", "Advanced"],
    flavor: ["Classical?"] // sneaker-classic vibe, but not Old-Beijing cloth
  },
  {
    id: "ooyaya",
    name: "Chinese Kung Fu Shoes, Tai Chi Shoes (OOYAYA)",
    img: "https://m.media-amazon.com/images/I/61MbGSkkptL._AC_SL1500_.jpg",
    price: 9.99,
    rating: 4.3,
    link: "https://www.amazon.com/dp/B0CMV6X8KY?tag=paht4change-20",
    sole: "Rubber (simple grip)",
    upper: "Canvas",
    tags: ["Indoor", "Beginner", "Classical"]
  },
  {
    id: "jiuqing",
    name: "JiuQing Tai Chi Shoes Men Women (EVA Sole)",
    img: "https://m.media-amazon.com/images/I/61t8qYBtoXL._AC_SL1500_.jpg",
    price: 31.83,
    rating: 5.0,
    link: "https://www.amazon.com/dp/B0CFJRLG23?tag=paht4change-20",
    sole: "EVA mid + TPR outsole (zero-drop feel)",
    upper: "Synthetic / Microfiber",
    tags: ["Indoor", "Advanced"]
  },
  {
    id: "xuhcly",
    name: "Tai Chi Shoes for Men Non Slip (XUHCLY)",
    img: "https://m.media-amazon.com/images/I/61wHxcIe53L._AC_SL1500_.jpg",
    price: 35.99,
    rating: 4.5,
    link: "https://www.amazon.com/XUHCLY-Martial-Leather-Training-Taekwondo/dp/B0DRFZLCRB?tag=paht4change-20",
    sole: "TPR Rubber (non-slip)",
    upper: "PU / Leather",
    tags: ["Indoor", "Advanced"]
  },
  {
    id: "yunpeng",
    name: "Chinese Slip Ons Traditional Old Beijing Shoes (YunPeng)",
    img: "https://m.media-amazon.com/images/I/715UCNMdOyL._AC_SL1500_.jpg",
    price: 21.88,
    rating: 4.0,
    link: "https://www.amazon.com/dp/B09TYSP3W8?tag=paht4change-20",
    sole: "Rubber (basic indoor traction)",
    upper: "Cotton",
    tags: ["Indoor", "Beginner", "Classical"]
  },
  {
    id: "mikitutu",
    name: "Martial Art Cloth Shoes Kung Fu Tai Chi Cotton Sole Canvas (Mikitutu)",
    img: "https://m.media-amazon.com/images/I/71Mr+1BKurL._AC_SL1500_.jpg",
    price: 16.99,
    rating: 4.0,
    link: "https://www.amazon.com/dp/B0CNBR2NP9?tag=paht4change-20",
    sole: "Cotton (very flexible, quiet)",
    upper: "Canvas",
    tags: ["Indoor", "Beginner", "Classical"]
  },
  {
    id: "buhcfbo",
    name: "Men's Barefoot Minimalist Slip On Cross-Trainer (BUHCFBO)",
    img: "https://m.media-amazon.com/images/I/61WnXNU86KL._AC_SL1500_.jpg",
    price: 17.83,
    rating: 4.2,
    link: "https://www.amazon.com/dp/B0DC61B1NP?tag=paht4change-20",
    sole: "Rubber (zero-drop, thin)",
    upper: "Mesh",
    tags: ["Indoor", "Outdoor", "Advanced"]
  },
  {
    id: "vidsid",
    name: "Chinese Traditional Martial Arts Shoes (VIDSID) — Waterproof",
    img: "https://m.media-amazon.com/images/I/51jrYUYu3oL._AC_SL1000_.jpg",
    price: 13.99,
    rating: 4.3,
    link: "https://www.amazon.com/dp/B0BQH33YSH?tag=paht4change-20",
    sole: "Rubber (injection-molded, waterproof)",
    upper: "Elastic / Knit",
    tags: ["Outdoor", "Beginner"]
  }
];

/* ------------ FILTERS ------------ */
const FILTERS = [
  { key: "all", label: "All" },
  { key: "Indoor", label: "Indoor" },
  { key: "Outdoor", label: "Outdoor" },
  { key: "Beginner", label: "Beginner" },
  { key: "Advanced", label: "Advanced" },
  { key: "Classical", label: "Classical" }
];

/* ------------ BLURBS (short + compact) ------------ */
const BLURBS = {
  feiyue:
    "Iconic low-profile canvas sneaker with flexible rubber sole — versatile for studio practice and short, dry walks.",
  ooyaya:
    "Simple canvas slip-ons with grippy outsole. Ultra-light, easy to pack, and budget-friendly for beginners.",
  jiuqing:
    "Zero-drop feel with EVA comfort and steady TPR grip. Stable heel and precise feedback for longer sessions.",
  xuhcly:
    "Breathable PU upper with non-slip TPR outsole that grips without grabbing. Supportive heel for steady pivots.",
  yunpeng:
    "Traditional cotton upper and low profile with basic indoor traction. Easy slip-on for morning forms and classes.",
  mikitutu:
    "Feather-light cotton sole keeps you close to the floor for slow forms and balance work — slipper-like comfort.",
  buhcfbo:
    "Wide toe box and zero-drop sole for a natural stance. Ultra-packable mesh upper for travel and quick sessions.",
  vidsid:
    "Stretchy upper with waterproof molded sole — handy for damp courtyards and humid days; light cushioning without bulk."
};

/* ------------ APP ------------ */
export default function App() {
  const [filterKey, setFilterKey] = useState("all");

  const visible = useMemo(() => {
    return PRODUCTS.filter(p => (filterKey === "all" ? true : p.tags.includes(filterKey)));
  }, [filterKey]);

  return (
    <div className="frame">
      <div className="scroller">
        <div className="page">
          <div className="wrap">
            <h1 className="h1">Top Tai Chi Shoes (Fall 2025)</h1>
            <p className="sub">
              Compact picks tuned for <strong>ground feel</strong>, <strong>traction</strong>, and{" "}
              <strong>comfort</strong>. Filter by surface and experience level.
            </p>

            <div className="filters">
              {FILTERS.map(f => (
                <button
                  key={f.key}
                  className={`f ${filterKey === f.key ? "active" : ""}`}
                  onClick={() => setFilterKey(f.key)}
                >
                  {f.label}
                </button>
              ))}
            </div>

            <div className="list">
              {visible.map((p) => (
                <article key={p.id} className="card">
                  <div className="left">
                    <img className="img" src={p.img} alt={p.name} loading="lazy" />
                  </div>
                  <div className="right">
                    <h2 className="t">{p.name}</h2>

                    <div className="meta">
                      <span><strong>Price:</strong> ${p.price.toFixed(2)}</span>
                      <span><strong>Rating:</strong> {p.rating ? `${p.rating}★` : "—"}</span>
                      <span><strong>Sole:</strong> {p.sole}</span>
                      <span><strong>Upper:</strong> {p.upper}</span>
                    </div>

                    <p className="d">
                      {BLURBS[p.id] ?? "Light, responsive feel for controlled pivots and balanced stances."}
                    </p>

                    <div className="tags">
                      {p.tags.map((t) => (
                        <span key={t} className="tag">{t}</span>
                      ))}
                    </div>

                    <a className="btn" href={p.link} target="_blank" rel="noopener noreferrer" aria-label={`Buy ${p.name} on Amazon`}>
                      Buy on Amazon
                    </a>
                  </div>
                </article>
              ))}
            </div>

            <p className="footer">
              <strong>Affiliate Disclosure:</strong> Links may be affiliate. Purchasing through them may earn us a commission at no extra cost to you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}